import { experimentalRichEditPolicy, type RichEditSkin, type RichEditVariant } from '@/app/richEdit'

export const FORUM_RICH_EDIT_VARIANT: RichEditVariant = 'std'
export const RICH_EDIT_POLICY = experimentalRichEditPolicy(FORUM_RICH_EDIT_VARIANT)

export const forumRichEditSkin: RichEditSkin = {
  root: 'flex min-h-0 flex-1 flex-col bg-white',
  modeBar: 'flex min-h-8 flex-wrap items-center gap-1 border-b border-[#006699] bg-[#dfe6ef] px-2 py-1',
  modeButton: 'h-6 cursor-pointer border border-[#006699] bg-[#eef3f8] px-2 text-[10px] font-bold text-[#006699]',
  modeButtonActive: 'h-6 cursor-pointer border border-[#003f63] bg-[#006699] px-2 text-[10px] font-bold text-white',
  toolbar: 'flex min-h-8 flex-wrap items-center gap-1 border-b border-[#006699] bg-[#eef3f8] px-2 py-1',
  toolbarGroup: 'flex flex-wrap items-center gap-1',
  button: 'flex h-6 min-w-6 items-center justify-center border border-[#006699] bg-white px-1.5 text-[10px] text-[#006699] hover:bg-[#dfe6ef] disabled:opacity-40',
  buttonActive: 'bg-[#006699] text-white',
  select: 'h-6 border border-[#006699] bg-white px-1 text-[10px]',
  color: 'h-6 w-7 cursor-pointer border border-[#006699] bg-white p-0.5',
  surfaceWrap: 'min-h-0 flex-1',
  surface: 'box-border h-full min-h-[420px] w-full overflow-auto bg-white p-3 text-[12px] leading-5 text-black outline-none [&_a]:text-[#006699] [&_img]:max-w-full',
  status: 'ml-auto text-[9px] text-[#555]',
  blocks: {
    toolbar: 'flex flex-wrap items-center gap-1 border-b border-[#006699] bg-[#eef3f8] px-2 py-1',
    stage: 'relative min-h-[420px] overflow-auto bg-[#dfe6ef]',
    block: 'group absolute box-border cursor-move overflow-hidden border border-[#006699] bg-white',
    blockSelected: 'border-[#ff6600] ring-1 ring-[#ff6600]',
    blockContent: 'h-full overflow-auto p-2 text-[11px] text-black outline-none cursor-text',
    handle: 'pointer-events-none absolute bottom-0 right-0 bg-[#006699] px-1 text-[9px] text-white',
    empty: 'flex min-h-[420px] items-center justify-center text-[11px]',
  },
  canvas: {
    toolbar: 'flex flex-wrap items-center gap-1 border-b border-[#006699] bg-[#eef3f8] px-2 py-1',
    stage: 'min-h-[420px] overflow-auto bg-[#dfe6ef] p-2',
    viewport: 'mx-auto w-fit bg-white',
    fallback: 'mx-auto max-w-full bg-white [&_svg]:block [&_svg]:h-auto [&_svg]:max-w-full',
  },
}
